const createAdapterDependencies = ({ adapters }) => Object.entries(adapters).map(([id, value]) => ({
    definition: { id, type: 'adapter', factory: () => value },
}));
export default createAdapterDependencies;
